import React from "react";
import Icon from "../Icon";
import Item from "./Item";

const menuGender = [
  {
    title: "Male",
    icon: <Icon.Male className="menu__icon" />
  },
  {
    title: "Female",
    icon: <Icon.Female className="menu__icon" />
  },
];

const menuOptions = [
  {
    title: "Walking",
    icon: <Icon.Walking className="menu__icon" />
  },
  {
    title: "Running",
    icon: <Icon.Running className="menu__icon" />
  },
  {
    title: "Standing",
    icon: <Icon.Standing className="menu__icon" />
  },
  {
    title: "Cycling",
    icon: <Icon.Cycling className="menu__icon" />
  }
];

const menuStyles = [
  {
    title: "Colorful",
    icon: <Icon.Colorful className="menu__icon" />
  },
  {
    title: "Duotone",
    icon: <Icon.Duotone className="menu__icon" />
  },
  {
    title: "Outline",
    icon: <Icon.Outline className="menu__icon" />
  }
];

const Menus = React.memo(({ gender, setGender, option, setOption, style, setStyle }) => {
  return (
    <>
      <Item
        className="menu--sex"
        menuList={menuGender}
        param={gender}
        setParam={setGender}
      />
      <div className="menu-group">
        <Item
          className="menu--vert"
          menuList={menuOptions}
          param={option}
          setParam={setOption}>
          <Icon.Poses />
        </Item>
        <Item
          className="menu--vert menu--right"
          menuList={menuStyles}
          param={style}
          setParam={setStyle}>
          <Icon.Styles />
        </Item>
      </div>
    </>
  )
});

Menus.displayName = 'Menus';

export default Menus;